// Centralized, deduplicated emitter for subscription-required events
// Prevents event storms when multiple parallel 402 responses arrive (e.g. analytics batch calls)
// and when UI proactively polls subscription status.

const COOLDOWN_MS = 5000; // minimum interval to re-emit identical status
let lastStatus = null;
let lastEmittedAt = 0;

/**
 * Emit a global 'subscription-required' CustomEvent with deduplication.
 * Re-emits immediately if status changed; otherwise only after cooldown.
 * @param {Object} opts
 * @param {string} opts.subscriptionStatus - e.g. 'EXPIRED','NONE','TRIAL_EXPIRED'
 * @param {string|undefined} [opts.expiryDate]
 * @param {string|undefined} [opts.message]
 * @param {boolean} [opts.force] - bypass cooldown & status check
 */
export function emitSubscriptionRequired({ subscriptionStatus, expiryDate, message, force = false }) {
  const now = Date.now();
  if (!force) {
    const sameStatus = subscriptionStatus && subscriptionStatus === lastStatus;
    if (sameStatus && (now - lastEmittedAt) < COOLDOWN_MS) {
      // Suppress duplicate emission
      return false;
    }
  }
  window.dispatchEvent(new CustomEvent('subscription-required', {
    detail: { subscriptionStatus, expiryDate, message }
  }));
  lastStatus = subscriptionStatus || lastStatus; // keep previous if undefined
  lastEmittedAt = now;
  return true;
}

/**
 * Reset internal emitter cache (useful for tests or logout events).
 */
export function resetSubscriptionEventCache() {
  lastStatus = null;
  lastEmittedAt = 0;
}
